// Russian dictionary. Typed against `Dictionary` (derived from `en.ts`), so a
// missing or extra key here is a compile error. Register: informal-neutral
// «вы». Brand name «Merkury» is kept as-is.

import type { Dictionary } from './en.js';

export const ru: Dictionary = {
  // --- Common ---------------------------------------------------------------
  'common.loading': 'Загрузка…',
  'common.continue': 'Продолжить',
  'common.cancel': 'Отмена',
  'common.back': 'Назад',
  'common.save': 'Сохранить',
  'common.accept': 'Принять',
  'common.decline': 'Отклонить',

  // --- Welcome (onboarding) -------------------------------------------------
  'welcome.tagline': 'Приватные голосовые звонки один на один.',
  'welcome.create': 'Создать аккаунт',
  'welcome.haveAccount': 'У меня уже есть аккаунт',
  'welcome.restorePasskey': 'Восстановить с помощью ключа доступа',

  // --- Display name (onboarding) --------------------------------------------
  'displayName.title': 'Выберите отображаемое имя',
  'displayName.help': 'Это имя друзья видят, когда вы звоните. Без почты и анкет.',
  'displayName.label': 'Отображаемое имя',

  // --- Pick avatar (onboarding, create path) --------------------------------
  'pickAvatar.title': 'Выберите изображение профиля',
  'pickAvatar.help':
    'Картинка из жидкой ртути, уникальная для вашего аккаунта. Друзья видят такую же. Изменить можно позже в настройках.',
  'pickAvatar.skip': 'Выбрать позже',

  // --- Avatar picker (shared) -----------------------------------------------
  'avatarPicker.label': 'Варианты изображения профиля',
  'avatarPicker.option': 'Вариант изображения {n}',
  'avatarPicker.showMore': 'Показать ещё',

  // --- Recovery phrase (onboarding, create path) ----------------------------
  'showPhrase.title': 'Ваша фраза восстановления',
  'showPhrase.intro1': 'Эти 24 слова — ',
  'showPhrase.only': 'единственный',
  'showPhrase.intro2':
    ' способ восстановить аккаунт. Если вы потеряете эту фразу и своё устройство, аккаунт будет утрачен навсегда — нет ни почты, ни службы поддержки, которые смогут его вернуть. Запишите её на бумаге и храните в надёжном месте. Не делайте скриншот и не сохраняйте в заметках.',
  'showPhrase.wroteDown': 'Я записал(а) фразу восстановления',

  // --- Confirm phrase (onboarding, create path) -----------------------------
  'confirmPhrase.title': 'Подтвердите фразу восстановления',
  'confirmPhrase.help': 'Введите запрошенные слова из фразы, которую вы только что записали.',
  'confirmPhrase.wordLabel': 'Слово №{n}',
  'confirmPhrase.error':
    'Эти слова не совпадают с вашей фразой восстановления. Проверьте свою запись и попробуйте снова.',

  // --- Restore phrase (onboarding, restore path) ----------------------------
  'restorePhrase.title': 'Восстановление аккаунта',
  'restorePhrase.help':
    'Введите или вставьте все 24 слова фразы восстановления по порядку. Пробелы, переносы строк, нумерация и регистр не важны. Восстановление воссоздаёт тот же самый ключ личности, поэтому друзья не увидят предупреждения о смене ключа.',
  'restorePhrase.label': 'Фраза восстановления',
  'restorePhrase.placeholder': 'apple banana cherry … (все 24 слова по порядку)',
  'restorePhrase.editWord': 'Изменить слово {n}',
  'restorePhrase.error':
    'Это не похоже на действительную фразу восстановления из 24 слов. Проверьте опечатки и попробуйте снова.',

  // --- Restore with a passkey (onboarding, WebAuthn PRF) --------------------
  'restorePasskey.title': 'Восстановление с помощью ключа доступа',
  'restorePasskey.help':
    'Используйте ключ доступа, сохранённый для вашего аккаунта, — устройство предложит его само, ничего вводить не нужно. Восстанавливается та же самая личность, поэтому друзья не увидят предупреждения о смене ключа. Если не сработает, используйте фразу восстановления. Пароль сам по себе не восстанавливает аккаунт — это лишь дополнительная проверка к ключу доступа или фразе.',
  'restorePasskey.useButton': 'Использовать ключ доступа',
  'restorePasskey.byId': 'Ключ не предлагается? Восстановить по идентификатору аккаунта',
  'restorePasskey.label': 'Идентификатор аккаунта',
  'restorePasskey.working': 'Восстановление…',
  'restorePasskey.continue': 'Восстановить',
  'restorePasskey.failed':
    'Не удалось восстановить по ключу доступа для этого аккаунта. Проверьте идентификатор или используйте фразу восстановления.',
  'restorePasskey.noCredential':
    'На этом устройстве не предложено ключа доступа для вашего аккаунта. Если вы сохранили его на другом устройстве, попробуйте там — или используйте фразу восстановления.',
  'restorePasskey.cancelled':
    'Запрос ключа доступа был закрыт. Попробуйте снова или используйте фразу восстановления.',
  'restorePasskey.unsupported':
    'Этот браузер не поддерживает ключи доступа. Используйте фразу восстановления.',
  'restorePasskey.usePhrase': 'Использовать фразу восстановления',

  // --- Restore password (onboarding, 2FA) -----------------------------------
  'restorePassword.title': 'Введите пароль аккаунта',
  'restorePassword.help':
    'Аккаунт защищён паролем — вторым фактором, заданным в настройках. Введите его, чтобы завершить восстановление на этом устройстве.',
  'restorePassword.label': 'Пароль',
  'restorePassword.signingIn': 'Вход…',
  'restorePassword.wrong': 'Неверный пароль. Попробуйте снова.',
  'restorePassword.tooMany':
    'Слишком много попыток — пароль не проверялся. Подождите несколько минут и попробуйте снова.',
  'restorePassword.checkFailed':
    'Не удалось проверить пароль (проблема с соединением). Вход не выполнен — попробуйте снова.',

  // --- Microphone (onboarding, native) --------------------------------------
  'microphone.title': 'Разрешите доступ к микрофону',
  'microphone.help':
    'Merkury — голосовое приложение, ему нужен микрофон, чтобы совершать и принимать звонки. Если разрешить сейчас, входящий звонок соединится сразу, а не застрянет на запросе разрешения, который не виден поверх экрана блокировки.',
  'microphone.denied':
    'Микрофон выключен, поэтому в звонках не будет звука. Вы можете разрешить его в любой момент в системных настройках в разделе Merkury.',
  'microphone.allow': 'Разрешить микрофон',
  'microphone.skip': 'Пропустить пока',

  // --- Notifications (onboarding) -------------------------------------------
  'onbNotifications.title': 'Включите уведомления',
  'onbNotifications.help':
    'Звонки друзей приходят, только если разрешены уведомления. Без них Merkury не сможет разбудиться и оповестить вас, пока приложение свёрнуто или закрыто.',
  'onbNotifications.denied':
    'Уведомления выключены, поэтому входящие звонки не будут приходить, пока приложение закрыто. Вы можете разрешить их в любой момент в системных настройках в разделе Merkury.',
  'onbNotifications.enable': 'Включить уведомления',
  'onbNotifications.skip': 'Пропустить пока',

  // --- Install hint (Safari/iOS «на экран „Домой"», JW9) ---------------------
  'installHint.ios.title': 'Добавьте Merkury на главный экран',
  'installHint.ios.body':
    'На iPhone и iPad Merkury может сообщать о входящих звонках только после добавления на главный экран — во вкладке браузера приложение не может разбудиться, чтобы оповестить вас.',
  'installHint.ios.step1': 'Нажмите кнопку «Поделиться» на панели инструментов.',
  'installHint.ios.step2': 'Выберите «На экран „Домой"».',
  'installHint.ios.step3': 'Откройте Merkury с главного экрана.',
  'installHint.denied.title': 'Уведомления заблокированы',
  'installHint.denied.body':
    'Входящие звонки не будут приходить, пока приложение Merkury закрыто, если не разрешены уведомления. Включите их для Merkury в настройках браузера или системы.',
  'installHint.dismiss': 'Скрыть',

  // --- Session ended (definitive remote revocation) ---------------------------
  'auth.sessionEnded.title': 'Сеанс завершён',
  'auth.sessionEnded.body':
    'Сеанс на этом устройстве завершён — с другого устройства или из-за необходимости повторного входа. Восстановите доступ с помощью ключа доступа или фразы восстановления, чтобы продолжить пользоваться Merkury здесь.',
  'auth.sessionEnded.action': 'Восстановить доступ',

  // --- Settings (aggregator) ------------------------------------------------
  'settings.title': 'Настройки',
  'settings.loading': 'Загрузка настроек…',
  'settings.echoTest': 'Проверка эха',
  'settings.echoHelp':
    'Записывает ~{secs} с с вашего микрофона и воспроизводит обратно — проверяет микрофон, динамик и разрешения, никому не звоня.',
  'settings.recording': 'Запись… говорите',
  'settings.playingBack': 'Воспроизведение…',
  'settings.audioLevel': 'Уровень звука',
  'settings.runAgain': 'Запустить снова',
  'settings.startEcho': 'Начать проверку эха',
  'settings.echoDone': 'Проверка эха завершена — если вы услышали себя, звук работает.',
  'settings.echoFailed': 'Проверка эха не удалась: {error}',
  'settings.recoveryPhrase': 'Фраза восстановления',
  'settings.recoveryWarn':
    'Любой, кто увидит эти 24 слова, получит ваш аккаунт. Убедитесь, что никто не смотрит на ваш экран.',
  'settings.nobodyWatching': 'Никто не видит мой экран',
  'settings.reveal': 'Показать фразу восстановления',
  'settings.hide': 'Скрыть',
  'settings.appVersion': 'Версия приложения',
  'settings.webClient': 'Merkury Web',
  'settings.version': 'вер. {version}',
  'settings.notConnectedTitle': 'Пока не подключено',
  'settings.notConnectedBody':
    'Это устройство ещё не зарегистрировано на сервере, поэтому настройки аккаунта пока недоступны. Регистрация повторяется автоматически, как только сервер станет доступен.',
  'settings.groups': 'Группы настроек',
  'settings.account': 'Аккаунт',
  'settings.security': 'Безопасность',
  'settings.notifications': 'Уведомления',
  'settings.calls': 'Звонки',
  'settings.sessions': 'Сеансы',
  'settings.language': 'Язык',
  'settings.ringtone': 'Мелодия звонка',
  'settings.ringtoneHelp': 'Нажмите на мелодию, чтобы прослушать её и выбрать для входящих звонков.',
  'settings.ringtonePlaying': 'Играет…',
  'ringtone.chime': 'Перезвон',
  'ringtone.arcade': 'Аркада',
  'ringtone.blip': 'Бип',
  'ringtone.pulse': 'Пульс',
  'ringtone.crystal': 'Кристалл',
  'ringtone.coin': 'Монетка',
  'ringtone.march': 'Марш',
  'ringtone.bounce': 'Отскок',
  'ringtone.laser': 'Лазер',
  'ringtone.fanfare': 'Фанфары',
  'settings.android': 'Настройки Android',
  'settings.developer': 'Для разработчика',
  'settings.aboutConnection': 'Об этом подключении',
  'settings.endpointVersion': 'Версия списка адресов:',
  'settings.closeDialog': 'Закрыть настройки',

  // --- App updates (Android self-update, docs/06 §4) -------------------------
  'updates.title': 'Обновления приложения',
  'updates.check': 'Проверить обновления',
  'updates.install': 'Скачать и установить',
  'updates.checking': 'Проверка…',
  'updates.downloading': 'Загрузка обновления…',
  'updates.upToDate': 'У вас последняя версия Merkury (проверено {time}).',
  'updates.notChecked': 'Проверка ещё не выполнялась.',
  'updates.available': 'Новая версия готова к установке.',
  'updates.popupTitle': 'Доступно обновление',
  'updates.later': 'Позже',
  'updates.installPrompted':
    'Подтвердите установку в системном окне. Merkury перезапустится на новой версии.',
  'updates.installPermission':
    'Разрешите «Установку неизвестных приложений» для Merkury в открывшемся окне, затем нажмите установить ещё раз.',
  'updates.errorOffline': 'Не удалось связаться с сервером. Попробуйте позже.',
  'updates.errorRejected': 'Обновление отклонено: не прошла проверка подписи.',
  'updates.errorDownload': 'Не удалось скачать ни с одного зеркала. Попробуйте позже.',

  // --- Settings chrome ------------------------------------------------------
  'chrome.backToSettings': 'Назад к настройкам',

  // --- Language settings ----------------------------------------------------
  'language.title': 'Язык',
  'language.system': 'Системный язык',
  'language.en': 'English',
  'language.ru': 'Русский',

  // --- Account settings -----------------------------------------------------
  'account.title': 'Аккаунт',
  'account.displayName': 'Отображаемое имя',
  'account.saved': 'Сохранено',
  'account.profilePicture': 'Изображение профиля',
  'account.profilePictureHelp':
    'Изображение из жидкой ртути, созданное на основе вашей учётной записи. Выберите то, что нравится, — друзья увидят такое же.',
  'account.avatarCurrent': 'Ваше текущее изображение',
  'account.noPictureYet': 'Изображение ещё не выбрано. Выберите одно из вариантов ниже.',
  'account.avatarOption': 'Вариант изображения {n}',
  'account.showMore': 'Показать ещё',
  'account.couldNotUpdateAvatar': 'Не удалось обновить изображение. Попробуйте снова.',
  'account.safetyNumbers': 'Коды безопасности',
  'account.safetyHelp':
    'Прочитайте это вслух во время звонка — если совпадает на обоих телефонах, звонок не перехвачен.',
  'account.contact': 'Контакт',
  'account.chooseContact': 'Выберите контакт…',
  'account.unavailableKey': 'Недоступно — ключ пока неизвестен.',
  'account.password': 'Пароль аккаунта',
  'account.useAtLeast8': 'Используйте не менее 8 символов.',
  'account.passwordsDontMatch': 'Пароли не совпадают.',
  'account.passwordChanged': 'Пароль изменён.',
  'account.passwordSet': 'Пароль установлен.',
  'account.couldNotUpdatePassword': 'Не удалось обновить пароль. Попробуйте снова.',
  'account.passwordRemoved':
    'Пароль удалён. Теперь ключ доступа или фраза восстановления сами по себе восстанавливают аккаунт на новом устройстве.',
  'account.couldNotRemovePassword': 'Не удалось удалить пароль. Попробуйте снова.',
  'account.passwordSetHelp':
    'Пароль установлен. Он работает как второй фактор: для восстановления на новом устройстве нужны ключ доступа или фраза восстановления И этот пароль. Сам по себе пароль никогда не восстанавливает аккаунт — но без него не смогут и они.',
  'account.passwordOptionalHelp':
    'Необязательный второй фактор. С установленным паролем украденной фразы восстановления или ключа доступа недостаточно для захвата аккаунта — для восстановления на новом устройстве потребуется ещё и пароль. Сам по себе пароль ничего не восстанавливает.',
  'account.newPassword': 'Новый пароль',
  'account.passwordLabel': 'Пароль',
  'account.confirmPassword': 'Подтвердите пароль',
  'account.signOutOthers': 'Также выйти на других устройствах',
  'account.changePassword': 'Изменить пароль',
  'account.setPassword': 'Установить пароль',
  'account.removePassword': 'Удалить пароль',
  'account.blockedUsers': 'Заблокированные пользователи',
  'account.nobodyBlocked': 'Никто не заблокирован.',
  'account.unblock': 'Разблокировать',
  'account.unblockAria': 'Разблокировать {userId}',
  'account.deleteAccount': 'Удалить аккаунт',
  'account.deleteHelp':
    'Безвозвратно стирает ваш аккаунт, друзей и историю звонков. Друзья просто увидят, что вы исчезли. Ваша фраза восстановления станет бесполезной. Это нельзя отменить.',
  'account.deleteOpen': 'Удалить мой аккаунт…',
  'account.typeIdConfirm': 'Введите свой ID ({userId}) для подтверждения',
  'account.yourPassword': 'Ваш пароль аккаунта',
  'account.deleting': 'Удаление…',
  'account.permanentlyDelete': 'Удалить навсегда',
  'account.deletionFailed': 'Не удалось удалить. Проверьте пароль и попробуйте снова.',

  // --- Sign out -------------------------------------------------------------
  'account.signOut': 'Выйти',
  'account.signOutHelp':
    'Выход на этом устройстве и удаление хранящейся здесь личности. Аккаунт не удаляется.',
  'account.signOutConfirm':
    'Чтобы снова войти, понадобится ключ доступа или фраза восстановления — плюс пароль аккаунта, если он установлен. Без них вернуться в аккаунт не получится.',
  'account.signOutConfirmButton': 'Выйти',
  'account.signingOut': 'Выход…',

  // --- Passkeys -------------------------------------------------------------
  'passkeys.title': 'Ключи доступа',
  'passkeys.help':
    'Ключи доступа входят с этого устройства на сервер. Ключ с поддержкой PRF может также восстановить аккаунт на новом устройстве; иначе по-прежнему нужна фраза восстановления.',
  'passkeys.couldNotLoad': 'Не удалось загрузить ключи доступа.',
  'passkeys.unsupported':
    'Это устройство не может управлять ключами доступа. Добавьте ключ из веб-приложения в браузере, который их поддерживает.',
  'passkeys.restorable':
    'Добавлено. Этот ключ доступа может восстановить аккаунт на новом устройстве.',
  'passkeys.sessionOnly':
    'Добавлено. Этот ключ доступа выполняет вход только на этом устройстве — он не восстановит новое устройство, поэтому сохраните фразу восстановления.',
  'passkeys.registered': 'Зарегистрированные ключи доступа',
  'passkeys.none': 'Ключей доступа пока нет.',
  'passkeys.defaultLabel': 'Ключ доступа',
  'passkeys.remove': 'Удалить',
  'passkeys.couldNotAdd': 'Не удалось добавить ключ доступа. Попробуйте снова.',
  'passkeys.alreadyOnDevice': 'На этом устройстве уже есть ключ доступа Merkury. Сначала удалите его, чтобы добавить новый.',
  'passkeys.expiredRetry': 'Слишком долго — запрос ключа устарел. Нажмите «Добавить ключ доступа» ещё раз.',
  'passkeys.wrongOrigin':
    'В этом браузере ключи доступа работают только на основном сайте. Откройте {domain} и добавьте ключ там.',
  'passkeys.couldNotRemove': 'Не удалось удалить этот ключ доступа.',
  'passkeys.namePlaceholder': 'Название ключа (необязательно)',
  'passkeys.newNameAria': 'Название нового ключа',
  'passkeys.adding': 'Добавление…',
  'passkeys.add': 'Добавить ключ доступа',

  // --- Sessions -------------------------------------------------------------
  'sessions.title': 'Сеансы',
  'sessions.kindAndroid': 'Приложение Android',
  'sessions.kindWeb': 'Веб',
  'sessions.active': 'Активные сеансы',
  'sessions.thisDevice': 'это устройство',
  'sessions.lastSeenLine': '{kind} · последний раз {when}',
  'sessions.unknown': 'неизвестно',
  'sessions.terminate': 'Завершить',
  'sessions.terminateAria': 'Завершить сеанс {name}',
  'sessions.terminateAll': 'Завершить все другие сеансы',

  // --- Notifications settings -----------------------------------------------
  'notifSettings.title': 'Уведомления',
  'notifSettings.callNotifications': 'Уведомления о звонках',
  'notifSettings.body':
    'Merkury оповещает о входящих звонках, используя разрешение на уведомления вашего устройства. Разрешите уведомления для Merkury в браузере или системных настройках, чтобы получать оповещения, когда приложение не открыто.',
  'notifSettings.web.enable': 'Включить уведомления',
  'notifSettings.web.granted': 'Уведомления включены — входящие звонки будут звонить на этом устройстве.',
  'notifSettings.web.denied':
    'Уведомления для Merkury заблокированы. Снова включите их в настройках сайта в браузере для этой страницы и перезагрузите её.',
  'notifSettings.web.unsupported': 'Этот браузер не поддерживает уведомления.',
  'notifHealth.allOk': 'Все проверки уведомлений пройдены — входящие звонки будут звонить на этом устройстве.',
  'notifHealth.blocked.title': 'Уведомления отключены',
  'notifHealth.blocked.body':
    'Merkury не может показывать входящие звонки, потому что уведомления отключены. Без них звонок только вибрирует, и на него нельзя ответить. Включите уведомления, чтобы входящие звонки показывались.',
  'notifHealth.blocked.action': 'Открыть настройки уведомлений',
  'notifHealth.channel.title': 'Оповещения о входящих звонках приглушены',
  'notifHealth.channel.body':
    'Категория уведомлений «Входящие звонки» отключена или понижена, поэтому звонок не может всплыть и зазвонить. Верните ей полные оповещения.',
  'notifHealth.channel.action': 'Открыть настройки категории',
  'notifHealth.dnd.title': 'Звонки не прозвонят в режиме «Не беспокоить»',
  'notifHealth.dnd.body':
    'Категории «Входящие звонки» не разрешено обходить режим «Не беспокоить», поэтому при нём звонки остаются беззвучными. Включите «Обход режима "Не беспокоить"» для этой категории.',
  'notifHealth.dnd.action': 'Открыть настройки категории',
  'notifHealth.fullScreen.title': 'Полноэкранные оповещения о звонках отключены',
  'notifHealth.fullScreen.body':
    'Android блокирует показ экрана входящего звонка Merkury, когда телефон заблокирован (некоторые телефоны сбрасывают это при каждом обновлении). Разрешите полноэкранные уведомления — если переключатель уже показывает ВКЛ, выключите и включите его заново.',
  'notifHealth.fullScreen.action': 'Открыть настройки',
  'notifHealth.battery.title': 'Оптимизация батареи может задерживать звонки',
  'notifHealth.battery.body':
    'Android может усыплять Merkury в фоне, задерживая или теряя push-сигналы входящих звонков. Отключите оптимизацию батареи для Merkury, чтобы звонки приходили надёжно.',
  'notifHealth.battery.action': 'Отключить оптимизацию батареи',

  // --- Ringtone settings ----------------------------------------------------
  'ringtone.title': 'Мелодия звонка',
  'ringtone.help': 'Звук, который проигрывается при входящих звонках.',
  'ringtone.current': 'Текущая:',
  'ringtone.default': 'По умолчанию',
  'ringtone.change': 'Сменить мелодию',

  // --- Android settings -----------------------------------------------------
  'android.title': 'Android',
  'android.stayReachable': 'Оставаться на связи',
  'android.stayReachableHelp':
    'Держит постоянное подключение для входящих звонков без push от Google — расходует больше батареи и показывает постоянное уведомление (этого требует Android).',
  'android.batteryWarn': 'Оптимизация батареи может задерживать звонки.',
  'android.allowBattery': 'Разрешить неограниченный расход батареи',
  'android.pushTransport': 'Транспорт push',
  'android.fcm': 'Google (FCM) — по умолчанию',
  'android.ntfy': 'ntfy (UnifiedPush) — для сетей, где Google заблокирован',
  'android.ntfyHelp':
    'Для ntfy нужно установленное приложение-распространитель UnifiedPush (например, приложение ntfy).',
  'android.noDistributor':
    'Распространитель UnifiedPush не найден — остаёмся на push от Google, пока он не установлен.',
  'android.ntfyAppTitle': 'Установите приложение ntfy',
  'android.ntfyAppHelp':
    'Merkury может получать звонки, даже когда сам не запущен, если установлено приложение ntfy. ntfy держит одно лёгкое соединение в фоне и будит Merkury в момент звонка — без него звонки звонят, только пока жива собственная фоновая служба Merkury.',
  'android.ntfyAppTrust': 'ntfy обращается только к собственному push-серверу Merkury — Google тут ни при чём.',
  'android.ntfyAppGet': 'Получить ntfy в Google Play',

  // --- Developer screen -----------------------------------------------------
  'developer.title': 'Для разработчика',
  'developer.testing': 'Проверка…',
  'developer.reachable': 'Сервер доступен · {ms} мс',
  'developer.httpError': 'Сервер отвечает, но /healthz вернул HTTP {status}.',
  'developer.corsBlocked':
    'Сервер доступен, но блокирует межсайтовые запросы — запустите его с DEV_CORS_ORIGINS=*.',
  'developer.unreachable': 'Не удалось связаться с сервером. Проверьте адрес, Wi-Fi и брандмауэр.',
  'developer.timeout': 'Нет ответа в течение {secs} с.',
  'developer.invalid': 'Введите адрес вида http://192.168.1.5:8080.',
  'developer.backendOverride': 'Переопределение сервера',
  'developer.overrideHelp1':
    'Направьте это приложение на другой сервер (например, ноутбук в вашей сети Wi-Fi). Введите адрес вида ',
  'developer.overrideHelp2':
    '. Кнопка «Проверить» только тестирует; ничего не применяется до «Сохранить и перезагрузить».',
  'developer.activeOverride': 'Активное переопределение:',
  'developer.placeholder': 'http://host:port',
  'developer.serverAddressAria': 'Адрес сервера',
  'developer.test': 'Проверить',
  'developer.saveReload': 'Сохранить и перезагрузить',
  'developer.resetDefault': 'Сбросить к значению по умолчанию',

  // --- Для разработчика → Диагностика (docs/10 §§1/4/5) ----------------------
  'diag.title': 'Диагностика',
  'diag.tabBrainLog': 'Журнал ядра',
  'diag.tabAppLog': 'Журнал приложения',
  'diag.tabSnapshot': 'Снимок состояния',
  'diag.logEmpty': 'Пока нет записей журнала.',
  'diag.copyPage': 'Скопировать эту страницу',
  'diag.copyAll': 'Скопировать всё',
  'diag.copied': 'Скопировано в буфер обмена.',
  'diag.copyFailed':
    'Браузер не дал доступ к буферу обмена. Текст ниже — выделите и скопируйте его вручную или сфотографируйте, это тоже подойдёт.',
  'diag.copyFallbackLabel': 'Текст диагностики для копирования',
  'diag.autoSend': 'Отправлять отчёты об ошибках автоматически',
  'diag.autoSendHelp':
    'Анонимные отчёты о неудачных соединениях: коды ошибок, публичные имена серверов, страна и мобильный оператор. Никогда — имена, контакты, содержание разговоров и ваш IP-адрес.',
  'diag.autoSendOff':
    'Выключено. Ничего не отправляется и не предлагается к отправке — ни по расписанию, ни когда приложение не может достучаться до серверов. Отчёт по-прежнему можно скопировать и отправить самостоятельно.',
  'diag.previewTitle': 'Предпросмотр отчёта',
  'diag.previewHelp': 'Точные байты, которые будут отправлены, — до того как что-либо уйдёт.',
  'diag.previewAction': 'Показать отчёт',
  'diag.previewLoading': 'Собираем отчёт…',
  'diag.previewEmpty':
    'Отчёта сейчас нет: с прошлого раза ничего не сбоило, поэтому и отправлять нечего.',
  'diag.previewEmptyWhy':
    'Диагностика работает — за эту сессию записано строк: журнал ядра {brain}, журнал приложения {app}. Отчёт формируется, когда соединение даёт сбой; журналы выше можно скопировать в любой момент.',
  'diag.previewFailed':
    'Не удалось собрать отчёт — хранилище диагностики не ответило. Попробуйте ещё раз; копирование журналов выше работает в любом случае.',
  'diag.previewCopy': 'Скопировать отчёт',
  'diag.previewSend': 'Отправить этот отчёт сейчас',
  'diag.previewSent': 'Поставлен в очередь. Уйдёт по тому маршруту, который ещё работает.',
  'diag.previewSendFailed':
    'Отчёт не поставлен в очередь. Он никуда не делся — скопируйте его и отправьте по каналу, которому доверяете.',
  'diag.disclosureTitle': 'Режим разработчика включён',
  'diag.disclosureBody':
    'Теперь Merkury будет отправлять анонимные журналы ошибок, чтобы мы видели, где приложение блокируют, и делали его труднее для блокировки. В отчёты попадают коды ошибок, публичные имена серверов, страна и мобильный оператор, а также версия приложения.',
  'diag.disclosureNever':
    'В них никогда не попадают ваше имя, контакты, сказанное вами и ваш IP-адрес — и любой отчёт можно полностью прочитать до отправки.',
  'diag.disclosureWhere':
    'Это можно выключить в любой момент: Настройки → Для разработчика → Диагностика → «{toggle}».',
  'diag.unavailable':
    'Не удалось открыть хранилище диагностики, поэтому переключатель ниже неактивен. Копирование по-прежнему работает.',
  'diag.disclosureOk': 'Понятно',

  // --- Contacts -------------------------------------------------------------
  'contacts.title': 'Контакты',
  'contacts.offlineAria': 'Merkury не в сети',
  'contacts.signalingDown': 'Сигнальное соединение отсутствует',
  'contacts.yourId': 'Ваш ID',
  'contacts.registering': 'регистрация…',
  'contacts.copied': 'Скопировано',
  'contacts.copy': 'Копировать',
  'contacts.allContacts': 'Все контакты',
  'contacts.noContacts': 'Пока нет контактов',
  'contacts.noContactsHelp':
    'Нажмите +, чтобы поделиться своим ID или отсканировать код друга — звонки работают только между контактами.',
  'contacts.blocked': 'Заблокирован',
  'contacts.openAria': 'Открыть {name}',
  'contacts.callAria': 'Позвонить {name}',
  'contacts.requests': 'Запросы',
  'contacts.friendRequests': 'Запросы в друзья',
  'contacts.addFriendAria': 'Добавить друга',
  'contacts.noRequests': 'Нет ожидающих запросов',
  'contacts.noRequestsHelp': 'Когда кто-то добавит ваш ID, его запрос появится здесь.',
  'contacts.requestsBadge': {
    one: '{count} входящий запрос',
    few: '{count} входящих запроса',
    many: '{count} входящих запросов',
    other: '{count} входящих запроса',
  },

  // --- Contact detail -------------------------------------------------------
  'contactDetail.back': 'Назад к контактам',
  'contactDetail.callHistory': 'История звонков',
  'contactDetail.history': 'История',
  'contactDetail.noCalls': 'С этим контактом пока нет звонков.',
  'contactDetail.call': 'Позвонить',
  'contactDetail.removeFav': 'Убрать из избранного',
  'contactDetail.addFav': 'В избранное',
  'contactDetail.unblock': 'Разблокировать',
  'contactDetail.block': 'Заблокировать',
  'contactDetail.blockConfirm':
    'Заблокировать {name}? Этот контакт не сможет вам звонить и не узнает об этом. Блокировка также удаляет его из списка контактов — если позже вы его разблокируете, для звонков придётся добавить его заново.',
  'contactDetail.blockConfirmButton': 'Да, заблокировать',
  'contactDetail.couldNotBlock':
    'Не удалось заблокировать этот контакт — проверьте подключение и попробуйте снова.',
  'contactDetail.couldNotUnblock':
    'Не удалось разблокировать этот контакт — проверьте подключение и попробуйте снова.',
  'contactDetail.removeFriend': 'Удалить из друзей',
  'contactDetail.removeFriendConfirm':
    'Удалить {name} из контактов? Чтобы снова звонить друг другу, придётся добавить друг друга заново.',
  'contactDetail.removeFriendConfirmButton': 'Да, удалить из друзей',
  'contactDetail.removingFriend': 'Удаление…',
  'contactDetail.couldNotRemoveFriend':
    'Не удалось удалить этот контакт — проверьте подключение и попробуйте снова.',
  'contactDetail.presenceApp': 'В сети',
  'contactDetail.presenceReachable': 'Доступен',
  'contactDetail.presenceOffline': 'Не в сети',
  'contactDetail.nickname': 'Псевдоним',
  'contactDetail.aka': 'он же {name}',
  'contactDetail.nicknameClear': 'Убрать',

  // --- Empty pane (desktop right-pane default) ------------------------------
  'emptyPane.brand': 'Merkury',
  'emptyPane.selectContact': 'Выберите контакт, чтобы посмотреть детали или позвонить',
  'emptyPane.yourId': 'Ваш ID',
  'emptyPane.showQr': 'Показать QR',
  'emptyPane.hideQr': 'Скрыть QR',

  // --- Main (Favorites + Recents) -------------------------------------------
  'main.serverConnection': 'Подключение к серверу: {label}',
  'main.serverSignaling': 'Сигнальное подключение к серверу',
  'main.signalingDown': 'отсутствует',
  'main.signalingConnecting': 'подключение',
  'main.signalingConnected': 'подключено',
  'main.signalingReconnecting': 'переподключение',
  'main.trying': 'Пытаемся связаться с Merkury… (попытка {n})',
  'main.retryNow': 'Повторить сейчас',
  'main.favorites': 'Избранное',
  'main.recents': 'Недавние',
  'main.noCalls': 'Пока нет звонков',
  'main.noCallsHelp': 'Звонки, которые вы совершаете и принимаете, появятся здесь.',
  'main.callBackAria': 'Перезвонить {name}',
  'main.missedBadge': {
    one: '{count} пропущенный звонок',
    few: '{count} пропущенных звонка',
    many: '{count} пропущенных звонков',
    other: '{count} пропущенного звонка',
  },

  // --- Sidebar (desktop shell) ----------------------------------------------
  'sidebar.searchPlaceholder': 'Поиск',
  'sidebar.searchAria': 'Поиск по контактам и звонкам',
  'sidebar.noMatches': 'Ничего не найдено',

  // --- Sync / dialer notices (shared) ---------------------------------------
  'sync.refreshError': 'Не удалось обновить с сервера — показан последний известный список.',
  'sync.refreshing': 'Обновление…',
  'call.offlineHint': '{name} не в сети — увидит пропущенный звонок',
  'dialer.couldNotStart': 'Не удалось начать звонок — попробуйте снова.',

  // --- Call history formatting ----------------------------------------------
  'callFormat.noAnswer': 'нет ответа',
  'callFormat.missed': 'пропущен',
  'callFormat.declined': 'отклонён',
  'callFormat.failed': 'не удался',

  // --- In-call screen -------------------------------------------------------
  'call.end.hangup': 'Звонок завершён',
  'call.end.declined': 'Звонок отклонён',
  'call.end.busy': 'Занято',
  'call.end.no_answer': 'Нет ответа',
  'call.end.missed': 'Пропущенный звонок',
  'call.end.answered_elsewhere': 'Отвечено на другом устройстве',
  'call.end.connection_lost': 'Соединение потеряно',
  'call.end.failed': 'Не удалось соединиться',
  'call.end.mic_denied':
    'Нужен доступ к микрофону — разрешите его для Merkury в системных настройках',
  'call.end.micBlocked':
    'Микрофон заблокирован для Merkury в этом браузере. Включите его в настройках сайта (значок замка в адресной строке) и попробуйте снова.',
  'call.end.security': 'Звонок заблокирован: проверка безопасности не пройдена',
  'call.phase.dialing': 'Вызов…',
  'call.phase.ringing_remote': 'Идут гудки…',
  'call.phase.connecting': 'Соединение…',
  'call.phase.reconnecting': 'Переподключение…',
  'call.keyChanged': 'Ключ безопасности изменился',
  'call.keyChangedBody':
    'Ключ безопасности этого контакта изменился. Так бывает при переустановке — или если кто-то перехватывает звонок. Сверьте с ним код безопасности, прежде чем доверять новому ключу.',
  'call.trustNewKey': 'Доверять новому ключу',
  'call.noActive': 'Нет активного звонка.',
  'call.callBack': 'Перезвонить',
  'call.unknownCaller': 'Неизвестный абонент',
  'call.returnToCall': 'Вернуться к звонку с {name}',
  'call.returnToCallWithTime': 'Вернуться к звонку с {name} — {time}',
  'call.duration': 'Длительность звонка',
  'call.safetyNumber': 'Код безопасности',
  'call.viaRelay': 'через ретранслятор',
  'call.connectionQuality': 'Качество соединения',
  'call.controls': 'Управление звонком',
  'call.mute': 'Выключить микрофон',
  'call.unmute': 'Включить микрофон',
  'call.speakerOn': 'Включить динамик',
  'call.routeEarpiece': 'Звук: динамик у уха — нажмите, чтобы сменить',
  'call.routeSpeaker': 'Звук: громкая связь — нажмите, чтобы сменить',
  'call.routeBluetooth': 'Звук: Bluetooth — нажмите, чтобы сменить',
  'call.routeWired': 'Звук: проводная гарнитура — нажмите, чтобы сменить',
  'call.speakerOff': 'Выключить динамик',
  'call.endCall': 'Завершить звонок',
  // Короткие подписи под круглыми кнопками звонка на десктопе (состояние — цветом).
  'call.muteShort': 'Микрофон',
  'call.audioShort': 'Звук',
  'call.endShort': 'Отбой',

  // --- Incoming call screen -------------------------------------------------
  'incoming.isCalling': 'звонит',
  'incoming.answerControls': 'Управление ответом',
  'incoming.incomingCall': 'Входящий звонок',
  'incoming.connecting': 'Соединение…',

  // --- Add friend -----------------------------------------------------------
  'addFriend.cameraDenied':
    'Доступ к камере запрещён. Разрешите камеру для Merkury в системных настройках или вставьте ID ниже.',
  'addFriend.noCamera': 'Подходящая камера не найдена — вставьте ID ниже.',
  'addFriend.cameraUnavailable': 'Камера недоступна. Вставьте ID вместо этого.',
  'addFriend.ownId': 'Это ваш собственный ID.',
  'addFriend.requestSent': 'Запрос в друзья отправлен.',
  'addFriend.couldNotSend': 'Не удалось отправить запрос. Проверьте ID и попробуйте снова.',
  'addFriend.notAnId': 'Это не похоже на ID Merkury или ссылку-приглашение.',
  'addFriend.copied': 'Скопировано в буфер обмена.',
  'addFriend.backHome': 'Назад на главную',
  'addFriend.title': 'Добавить друга',
  'addFriend.myCode': 'Мой код',
  'addFriend.shareLink': 'Поделиться моей ссылкой',
  'addFriend.shareId': 'Поделиться моим ID',
  'addFriend.registering': 'Ваш ID ещё регистрируется…',
  'addFriend.scanCode': 'Отсканировать код',
  'addFriend.stopScanning': 'Остановить сканирование',
  'addFriend.scanFriend': 'Отсканировать код друга',
  'addFriend.scanUnsupported':
    'Сканирование не поддерживается на этом устройстве — вставьте ID ниже.',
  'addFriend.pasteId': 'Вставить ID',
  'addFriend.friendIdLabel': 'ID друга или ссылка-приглашение',
  'addFriend.sendRequest': 'Отправить запрос',
  'addFriend.pendingRequests': 'Ожидающие запросы',
  'addFriend.pending': 'Ожидают',
  'addFriend.noPending': 'Нет ожидающих запросов.',
  'addFriend.incoming': 'входящий',
  'addFriend.outgoingPending': 'исходящий · ожидает',

  // --- QR code --------------------------------------------------------------
  'qr.error': 'Не удалось создать QR-код для этой ссылки.',
  'qr.aria': 'QR-код для {value}',

  // --- Tab bar --------------------------------------------------------------
  'tabs.primary': 'Основное',
  'tabs.main': 'Главная',
  'tabs.contacts': 'Контакты',
  'tabs.settings': 'Настройки',

  // --- Push notifications (service worker) -----------------------------------
  'push.incomingTitle': 'Входящий звонок',
  'push.missedTitle': 'Пропущенный звонок',
  'push.incomingBody': 'Вам звонят в Merkury.',
  'push.missedBody': 'Вы пропустили звонок в Merkury.',
  'push.accept': 'Ответить',
  'push.decline': 'Отклонить',
  'push.endedTitle': 'Звонок завершён',
  'push.endedBody': 'Звонок больше не активен.',
};
